<template>
  <div>
    <Upload
      ref="uploadFile"
      :format="format"
      :show-upload-list="false"
      :on-progress="handleProgress"
      :on-success="handleSuccess"
      :on-exceeded-size="handleMaxSize"
      :on-format-error="handleFormatError"
      :before-upload="handleBeforeUpload"
      :max-size="size"
      :action="url"
    >
      <Button icon="ios-cloud-upload-outline">上传文件</Button>
    </Upload>
    <div>
      <ul
        class="file-list"
        v-for="(item, index) in uploadList"
        :key="index"
      >
        <li>
          <span style="font-size: 12px;">{{ item.name }}</span>
          <Icon
            type="ios-close"
            size="20"
            style="cursor: pointer; float: right;"
            @click="delFileList(item)"
          ></Icon>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      uploadList: [],
      isUploading: false,
    };
  },
  props: {
    format: {
      type: Array,
    },
    url: {
      type: String,
    },
    size: {
      type: Number,
    },
  },
  methods: {
    delFileList(item) {
      this.uploadList.splice(this.uploadList.indexOf(item), 1);
    },
    handleSuccess(res, file) {
      this.$Notice.destroy();
      this.isUploading = false;
      if (res.code != 200) {
        this.uploadList = [];
        this.$Notice.warning({
          title: "上传失败",
          desc: file.name + res.msg,
        });
      } else {
        file.name = res.data;
        if (this.size == 32768) {
          this.$Notice.close("fileLoading");
          this.$Notice.success({
            title: "文件上传成功！",
          });
        }
        this.$emit("fileResult", res);
      }
    },
    handleProgress() {
      if (!this.isUploading) {
        this.$Notice.destroy();
        this.$Notice.warning({
          title: "文件上传中...",
          name: "fileLoading",
          duration: 0,
        });
      }
      this.isUploading = true;
    },
    handleFormatError(file) {
      this.$Notice.warning({
        title: "文件格式不正确",
        desc: file.name + "的文件格式不正确.",
      });
    },
    handleBeforeUpload() {
      const check = this.uploadList.length < 1;
      if (!check) {
        this.$Notice.warning({
          title: "最多上传一个文件.",
        });
      }
      return check;
    },
    handleMaxSize(file) {
      this.$Notice.warning({
        title: "超过文件大小限制",
        desc:
          this.size == 32768
            ? "文件 " + file.name + " 太大, 不能超过32MB."
            : "文件 " + file.name + " 太大, 不能超过" + this.size + "KB.",
      });
    },
  },
  mounted() {
    this.uploadList = [];
  },
};
</script>
<style lang="scss" scoped>
.file-list {
  margin-top: 8px;
  li {
    &:hover {
      background: #f3f3f3;
    }
  }
}
</style>
